import { enqueueSnackbar } from "notistack";
import { useTranslation } from "react-i18next";

import CommonAlert from "@/components/CommonAlert";
import { useUpdateTaskStatusMutation } from "@/requests/tracking.mutations";
import { useTrackingActions, useTrackingShowTaskUpdateDialog } from "@/stores/use-tracking-table";

function UpdateTaskStatus() {
    const { t } = useTranslation();
    const { mutateAsync, isPending } = useUpdateTaskStatusMutation();

    const showTaskUpdateDialog = useTrackingShowTaskUpdateDialog();
    const { updateShowTaskUpdateDialog } = useTrackingActions();
    const handleConfirm = async () => {
        if (isPending || !showTaskUpdateDialog) return;
        try {
            const res = await mutateAsync({
                id: showTaskUpdateDialog.id,
                status: showTaskUpdateDialog.next,
            });
            enqueueSnackbar(t(res.message || ""), { variant: "success" });
        } catch (error) {
            console.error("IsDeletion error:", error);
        }
        handleClose();
    };

    const handleClose = () => {
        updateShowTaskUpdateDialog(null);
    };
    if (!showTaskUpdateDialog) return null;

    return (
        <CommonAlert
            open={!!showTaskUpdateDialog}
            loading={isPending}
            description="confirmations.updateTaskStatus"
            color="primary"
            onClose={handleClose}
            handleConfirm={handleConfirm}
            html
            descriptionOpts={{
                current: t(`taskStatuses.${showTaskUpdateDialog.current}`),
                next: t(`taskStatuses.${showTaskUpdateDialog.next}`),
            }}
        ></CommonAlert>
    );
}

export default UpdateTaskStatus;
